import { EventTrackerStatusEnum, EventTypeCodeEnum } from '@src/entities/Event/includes/schemas';

export const DefaultEventEntity = {
  actualRecordCount: 0,
  associatedActionPathId: null,
  createdBy: '',
  createdDate: '',
  endDate: null,
  eventId: null,
  eventTrackerStatus: EventTrackerStatusEnum.enum.ACTIVE,
  eventTypeCode: EventTypeCodeEnum.enum.OTHER,
  expectedRecordCount: 0,
  impactedSystems: [],
  lastModifiedBy: '',
  lastModifiedDate: '',
  notes: '',
  startDate: '',
  title: '',
};
